var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m22.143 39.646h0.10001c0.5 0.10001 1-0.29998 1.1-0.9v-5.3h1c0.5 0.10001 1-0.29998 1.1-0.9v-2c0-2.1 1-4 2.7-5.3 2.2-1.5 3.6-4 3.6-6.7v-3.4c0-0.6-0.4-1-1-1h-2.7v-7.1c-0.10001-0.8-0.8-1.5-1.6-1.4-0.8 0-1.4 0.6-1.5 1.4v7.1h-5.3v-7.1c-0.10001-0.8-0.8-1.5-1.6-1.4-0.8-0.10001-1.5 0.6-1.6 1.4v7.1h-2.6c-0.6 0-1 0.4-1 1v3.4c0 2.7 1.3 5.2 3.5 6.7 1.7 1.2 2.8 3.2 2.8 5.3v2c0.10001 0.5 0.5 0.9 1 0.9h1.1v5.3c0 0.5 0.4 0.9 0.9 0.9zm3.8-32.6c0-0.29998 0.29998-0.5 0.6-0.5s0.5 0.20001 0.5 0.5v7.1h-1.1zm-8.3 0c-0.10001-0.29998 0.20001-0.5 0.5-0.5 0.29998 0 0.5 0.20001 0.5 0.5v7.1h-1zm0.20001 16.8c-1.7-1.2-2.8-3.2-2.8-5.3v-2.5h14.7v2.5c0 2.1-1.1 4.1-2.8 5.3-2.2 1.5-3.5 4-3.5 6.7v1.1h-2.1v-1.1c-0.1-2.7-1.4-5.2-3.5-6.7z",
  fill: "#505050"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m21.343 31.646h2.1v-1.1c0-2.7 1.3-5.2 3.5-6.7 1.7-1.2 2.8-3.2 2.8-5.3v-2.5h-14.8v2.5c0 2.1 1.1 4.1 2.8 5.3 2.2 1.5 3.5 4 3.5 6.7v1.1zm-1.2-9.5h4.3c0.29998 0 0.5 0.20001 0.5 0.5 0 0.29998-0.20001 0.5-0.5 0.5h-4.2c-0.29998 0-0.6-0.20001-0.6-0.5 0-0.29998 0.29998-0.5 0.5-0.5zm-0.5-1.4c0-0.29998 0.20001-0.5 0.5-0.5h4.3c0.29998 0 0.5 0.20001 0.5 0.5 0 0.29998-0.20001 0.5-0.5 0.5h-4.2c-0.20001 0-0.5-0.20001-0.6-0.5zm0-1.9c0-0.20001 0.29998-0.4 0.5-0.4h4.3c0.20001 0 0.5 0.20001 0.5 0.4 0 0.29998-0.20001 0.5-0.5 0.5h-4.2c-0.20001 0-0.5-0.20001-0.6-0.5zm-1-4.7v-7.1c0-0.29998-0.20001-0.5-0.5-0.5-0.29998 0-0.6 0.20001-0.6 0.5h0.10001v7.1zm8.5 0v-7.1c0-0.29998-0.20001-0.5-0.5-0.5-0.29998 0-0.6 0.20001-0.6 0.5v7.1z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m20.343 19.346h4.2c0.29998 0 0.5-0.20001 0.5-0.5 0-0.20001-0.29998-0.4-0.5-0.4h-4.3c-0.20001 0-0.5 0.20001-0.5 0.4 0 0.29998 0.29998 0.5 0.6 0.5z",
  fill: "#28b557"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m20.343 21.246h4.2c0.29998 0 0.5-0.20001 0.5-0.5 0-0.29998-0.20001-0.5-0.5-0.5h-4.3c-0.29998 0-0.5 0.20001-0.5 0.5 0 0.29998 0.29998 0.5 0.6 0.5z",
  fill: "#4ab8dc"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m20.343 23.146h4.2c0.29998 0 0.5-0.20001 0.5-0.5 0-0.29998-0.29998-0.5-0.6-0.5h-4.3c-0.29998 0-0.5 0.20001-0.5 0.5 0.10001 0.29998 0.4 0.5 0.7 0.5z",
  fill: "#f2724a"
});

function SvgElectrical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectrical);
export default __webpack_public_path__ + "static/media/electrical.df1aea33234359c18a9126968acbba39.svg";
export { ForwardRef as ReactComponent };